import { useEffect, useRef, useState } from 'react';

import { P2 } from '@/lib/shared/components/Typography';
import { DownIcon } from '@/lib/shared/icons';
import { FILTER_ICONS } from '@/lib/shared/icons/map';
import { IClassname } from '@/lib/shared/model/classname';

import { clsx } from 'clsx';
import { useTranslation } from 'next-i18next';

import styles from './MapFilter.module.scss';

const FILTERS = [
  {
    name: 'BEACH',
    icon: FILTER_ICONS.FilterBeach,
  },
  {
    name: 'SCHOOL',
    icon: FILTER_ICONS.FilterSchool,
  },
  {
    name: 'HOSPITAL',
    icon: FILTER_ICONS.FilterHospital,
  },
  {
    name: 'MALL',
    icon: FILTER_ICONS.FilterMall,
  },
  {
    name: 'RESTAURANT',
    icon: FILTER_ICONS.FilterBar,
  },
  {
    name: 'GYM',
    icon: FILTER_ICONS.FilterGym,
  },
  {
    name: 'SUPERMARKET',
    icon: FILTER_ICONS.FilterShop,
  },
  {
    name: 'ATTRACTION',
    icon: FILTER_ICONS.FilterSS,
  },
  {
    name: 'TENNIS',
    icon: FILTER_ICONS.FilterTennis,
  },
  {
    name: 'GOLF',
    icon: FILTER_ICONS.FilterGolf,
  },
];
type MapFilterProps = IClassname & {
  filters: string[];
  toggleFilterQuery: (val: string) => void;
};
export const MapFilter = ({
  className,
  filters,
  toggleFilterQuery,
}: MapFilterProps) => {
  const { t } = useTranslation('index');
  const listRef = useRef<HTMLUListElement | null>(null);
  const [shownIcon, setShownIcon] = useState<
    undefined | 'down' | 'up' | 'none'
  >('down');

  useEffect(() => {
    if (listRef.current) {
      if (
        listRef.current.scrollHeight -
          listRef.current.getBoundingClientRect().height <
        20
      ) {
        setShownIcon('none');
      }
    }
  }, []);
  return (
    <div className={clsx(styles.filter, className)}>
      <P2 className={styles.filter__title}>{t('placesNearby')}</P2>
      <ul
        className={styles.filter__list}
        ref={listRef}
        onScroll={(e) => {
          const elem = e.currentTarget;
          const height = elem?.getBoundingClientRect()?.height;
          const scrollAmount = elem.scrollTop;
          const scrollHeight = elem.scrollHeight - height;

          if (scrollAmount > +'10' && scrollHeight - scrollAmount > +'10') {
            setShownIcon(undefined);
          } else if (scrollHeight - scrollAmount > +'10') {
            setShownIcon('down');
          } else if (scrollAmount > +'10') {
            setShownIcon('up');
          } else {
            setShownIcon('none');
          }
        }}
      >
        {shownIcon !== 'down' && shownIcon !== 'none' && (
          <li
            className={styles.filter__scrollTop}
            onClick={() => {
              listRef.current?.scrollTo({
                top: 0,
                behavior: 'smooth',
              });
            }}
          >
            <DownIcon />
          </li>
        )}
        {FILTERS.map((item) => {
          const isActive = filters.includes(item.name) || filters.length === 0;
          return (
            <li
              key={item.name}
              onClick={() => toggleFilterQuery(item.name)}
              className={clsx(
                styles.filter__item,
                isActive && styles['filter__item--selected']
              )}
            >
              {item.icon({})}
              <P2>{t(item.name)}</P2>
            </li>
          );
        })}
        {shownIcon !== 'up' && shownIcon !== 'none' && (
          <li
            className={styles.filter__scrollBottom}
            onClick={() => {
              listRef.current?.scrollTo({
                top: listRef.current.scrollHeight,
                behavior: 'smooth',
              });
            }}
          >
            <DownIcon />
          </li>
        )}
      </ul>
    </div>
  );
};
